// src/DashboardLayout.jsx
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './DashboardLayout.css'; // import the styles
import LogoutButton from './LogoutButton';

function DashboardLayout() {
  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          EpicNyte Admin
        </div>
        <nav>
          <ul>
            {/* Spacer to push nav items down 20vh */}
            <li style={{ flexBasis: '20vh', flexShrink: 0 }}></li>

            {/* Main nav items */}
            <li>
              <NavLink to="footfall" className={({ isActive }) => (isActive ? 'active' : '')}>
                Footfall
              </NavLink>
            </li>
            <li>
              <NavLink to="venues" className={({ isActive }) => (isActive ? 'active' : '')}>
                Venues
              </NavLink>
            </li>
            <li>
              <NavLink to="locations" className={({ isActive }) => (isActive ? 'active' : '')}>
                Locations
              </NavLink>
            </li>
            <li>
              <NavLink to="music" className={({ isActive }) => (isActive ? 'active' : '')}>
                Music
              </NavLink>
            </li>

            {/* Spacer between last nav item and logout (30vh) */}
            <li style={{ flexBasis: '30vh', flexShrink: 0 }}></li>

            {/* Logout button */}
            <li className="logout-item">
              <LogoutButton />
            </li>
          </ul>
        </nav>
      </aside>
      <main className="content">
        <Outlet /> {/* This renders the child routes */}
      </main>
    </div>
  );
}

export default DashboardLayout;